/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 -t --transform CreatorsCorner.glb 
Files: CreatorsCorner.glb [21.31KB] > C:\Users\fedde\Downloads\v2\CreatorsCorner-transformed.glb [21.71KB] (-2%)
*/

import { useRef } from "react";
import { useGLTF } from "@react-three/drei";
import { GLTF } from "three-stdlib";
import { Euler, Mesh, MeshStandardMaterial, Vector3 } from "three";
import { CalloutProps } from "../../components/Callout";
import { Icon, IconProps } from "../../components/Icon";

type GLTFResult = GLTF & {
  nodes: {
    WebExp_CreatorsCorner: Mesh;
  };
  materials: { [name: string]: MeshStandardMaterial };
};

export function CreatorsCorner() {
  const normalizedPosition = new Vector3(0, 0, 0);
  const normalizedRotation = new Euler(0, 0, 0);
  const calloutProps: CalloutProps = {
    graphicTexturePath: "/images/IconGraphic.png",
    graphicGlb: "/models/Callout/CalloutPlanev02.glb",
    graphicLocation: new Vector3(-0.59, -0.1, 1.1),
    textTitle: "Creators Corner",
    textTitleFont: "/fonts/bebas-neue-v9-latin-regular.woff",
    textTitleColor: "#ffffff",
    textTitleFontSize: 0.4,
    textTitlePosition: new Vector3(-0.6, 0, 1),
    textSubTitle: "Creative Core",
    textSubTitleFontSize: 0.2,
    textSubTitleFont: "/fonts/bebas-neue-v9-latin-regular.woff",
    textSubTitleColor: "#00EAFF",
    textSubTitlePosition: new Vector3(-0.61, -0.4, 1.21),
    scaleSpeed: 5,
    pivotPoint: new Vector3(-30.8385, -12.3122, 18.7412),
    active: false,
  };
  const iconProps: IconProps = {
    name: "Creators Corner",
    blenderPosition: new Vector3(-30.8385, -18.7412, -12.3122),
    idleRotationSpeed: 0.5,
    hoverTranslateY: 5,
    hoverLookAtFactor: 5,
    selectorDimensions: [8, 12, 8],
    paddingLeaveDimensions: [15, 15, 15],
    hoverRotationY: 4,
    cameraPositionSelected: new Vector3(-30.8385, -12.3122, 38.7412),
    cameraTargetSelected: new Vector3(-30.8385, -12.3122, 18.7412),
    calloutProps: calloutProps,
  };

  //REFS
  const creatorsCornerRef = useRef(null);
  const { nodes } = useGLTF(
    "/models/CreatorsCorner-transformed.glb"
  ) as GLTFResult;
  return (
    <Icon
      name={iconProps.name}
      blenderPosition={iconProps.blenderPosition}
      idleRotationSpeed={iconProps.idleRotationSpeed}
      hoverTranslateY={iconProps.hoverTranslateY}
      hoverLookAtFactor={iconProps.hoverLookAtFactor}
      selectorDimensions={iconProps.selectorDimensions}
      paddingLeaveDimensions={iconProps.paddingLeaveDimensions}
      hoverRotationY={iconProps.hoverRotationY}
      cameraPositionSelected={iconProps.cameraPositionSelected}
      cameraTargetSelected={iconProps.cameraTargetSelected}
      calloutProps={calloutProps}
    >
      <group
        ref={creatorsCornerRef}
        dispose={null}
        position={normalizedPosition}
        rotation={normalizedRotation}
        scale={1}
      >
        <mesh
          geometry={nodes.WebExp_CreatorsCorner.geometry}
          material={nodes.WebExp_CreatorsCorner.material}
          rotation={[Math.PI, 0, 2.618]}
        />
      </group>
    </Icon>
  );
}

useGLTF.preload("/models/CreatorsCorner-transformed.glb");
